module.exports = __webpack_public_path__ + "img/button_check_off.bee8c562.png";